import React from "react";
import { projects } from "../data/portfolio";

const ICONS = ["📁", "📁", "📁"];

const ProjectRow = ({ project, icon, navigate }) => (
  <article className="win-raised p-3">
    <div className="flex flex-wrap items-center justify-between gap-2 text-[11px] font-bold uppercase tracking-wide text-[#404040]">
      <span className="flex items-center gap-2 text-sm normal-case text-win-text">
        <span aria-hidden="true">{icon}</span>
        {project.category}
      </span>
      <span>{project.year}</span>
    </div>

    <h3 className="mt-2 text-xl font-black sm:text-2xl">{project.title}</h3>
    <p className="mt-2 text-sm leading-6">{project.description}</p>
    <p className="win-sunken-thin mt-3 px-3 py-2 text-xs leading-5 text-[#303030]">{project.impact}</p>

    <div className="mt-3 flex flex-wrap gap-1.5">
      {project.stack.map((item) => (
        <span key={item} className="win-raised px-2 py-1 text-[11px] font-bold">
          {item}
        </span>
      ))}
    </div>

    <div className="mt-4 flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => navigate(`project/${project.slug}`)}
        className="win-btn win-focus-dotted px-3 py-1.5 text-xs font-bold"
      >
        📄 View details
      </button>
      {project.websiteLink && (
        <a
          href={project.websiteLink}
          target="_blank"
          rel="noopener noreferrer"
          className="win-btn win-focus-dotted flex items-center px-3 py-1.5 text-xs font-bold"
        >
          🌐 View live
        </a>
      )}
      {project.githubLink && (
        <a
          href={project.githubLink}
          target="_blank"
          rel="noopener noreferrer"
          className="win-btn win-focus-dotted flex items-center px-3 py-1.5 text-xs font-bold"
        >
          💾 Source code
        </a>
      )}
      {project.accessNote && (
        <div className="win-sunken-thin flex items-center px-3 py-1.5 text-xs">
          <span className="mr-1.5 font-bold text-win-navy">🔒 Private:</span>
          {project.accessNote}
        </div>
      )}
    </div>
  </article>
);

const ProjectsWindow = ({ navigate }) => {
  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex items-center gap-2 px-2 py-1 text-xs">
        <span aria-hidden="true">📁</span>
        C:\JAKOB\PROJECTS ({projects.length} items)
      </div>
      <div className="flex-1 space-y-3 overflow-auto px-2 pb-2">
        {projects.map((project, index) => (
          <ProjectRow key={project.slug} project={project} icon={ICONS[index] || "📁"} navigate={navigate} />
        ))}
      </div>
    </div>
  );
};

export default ProjectsWindow;
